import React from 'react';

import { Card, CardContent, Typography, makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  cartao: {
    borderRadius: 12,
    transition: '0.2s',
    '&:hover': {
      transform: 'translateY(-4px)',
      boxShadow: theme.shadows[4],
    },
  },
  conteudo: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  colunaEsquerda: {
    display: 'flex',
    flexDirection: 'column',
  },
  rotulo: {
    fontSize: 13,
    color: '#777',
  },
  destaque: {
    fontSize: 24,
    fontWeight: 600,
  },
  subtitulo: {
    fontSize: 13,
    color: '#999',
  },
  icone: {
    fontSize: 36,
    opacity: 0.3,
  },
}));

function CartaoIndicador({ rotulo, destaque, subtitulo, cor, icone }) {
  const classes = useStyles();

  return (
    <Card className={classes.cartao} style={{ borderLeft: `6px solid ${cor}` }}>
      <CardContent className={classes.conteudo}>
        <div className={classes.colunaEsquerda}>
          <Typography className={classes.rotulo}>{rotulo}</Typography>

          <Typography className={classes.destaque}>{destaque}</Typography>

          {subtitulo !== undefined && subtitulo !== null && (
            <Typography className={classes.subtitulo}>{subtitulo}</Typography>
          )}
        </div>

        <div className={classes.icone} style={{ color: cor }}>
          {icone}
        </div>
      </CardContent>
    </Card>
  );
}

export default CartaoIndicador;
